<template>
    <div id="bottomBar" class="bottomBar">
        <!--<div class="botMenu">
            <div class="login">
                <router-link :to="{name:'Login'}">Login</router-link>
            </div>
            <div class="reginster">
                <router-link :to="{name:'Registration'}">Register</router-link>
            </div>
        </div>-->
    </div>
</template>

<script>
    export default {
        name: "BottomBar",
    }
</script>
